import { Injectable } from "@angular/core";
import { HttpClient } from "../shared/wrappers/HttpClient";


@Injectable()
export class DashboardService {
    constructor(private httpClient: HttpClient) { }

    endPoint: String = '/dashboard';
    data:any;

    async getData(year,month){
        let query = `?year=${year}&month=${month}`;
        this.data = await this.httpClient.get(`${this.endPoint}${query}`);
        return this.data;
    }

}




// WEBPACK FOOTER //
// ./src/app/services/dashboard.service.ts